import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios'
import { Url } from '../Url'
import { FaTruck, FaSearch, FaCalendarAlt, FaUser, FaFolderOpen, FaClock, FaDollarSign, FaEye, FaEdit, FaLock, FaTrash } from 'react-icons/fa'


const ListadoRepartos = () => {
    const [repartos, setRepartos] = useState([])
    const [usuarios, setUsuarios] = useState([])
    const [usuario, setUsuario] = useState(0)
    const [total, setTotal] = useState(0)
    const [fechaInicio, setFechaInicio] = useState('')
    const [fechaFin, setFechaFin] = useState('')
    const [estado, setEstado] = useState(true)
    const { setRepartoSelected, setFormView, setViewOpen, modify, idUsuario } = useContext(ContextStates)

    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof repartos !== 'undefined') {
                repartos.forEach(element => {
                    t = t + parseInt(element.total)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [repartos])

    useEffect(() => {
        const getUsuarios = async () => {
            const formData = new FormData()
            formData.append('usuariocero', 1);
            formData.append('local', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listUsrs.php',
                    method: 'POST',
                    data: formData,
                })
                console.log("usuarios ", results)
                setUsuarios(results.data.results);
                setUsuario(results.data.results[0].id)
            } catch (e) {
                console.log(e)
            }
        }
        getUsuarios()
    }, [])

    useEffect(() => {
        const consultaRepartos = async () => {
            let estRep = '';
            if (estado) {
                estRep = 0;
            }
            const formData = new FormData()
            formData.append('fechainicio', fechaInicio)
            formData.append('fechafin', fechaFin)
            formData.append('usuario', usuario)
            formData.append("idusuario", idUsuario)
            formData.append("estado", estRep)

            try {
                const response = await axios({
                    url: Url + 'api/listadoRepartos.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(response)
                setRepartos(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaRepartos()
    }, [fechaInicio, fechaFin, modify, usuario, estado])

    const handleView = (item) => {
        setRepartoSelected(item)
        setFormView(205)
        setViewOpen(true)
    }

    const handleEdit = (item) => {
        setRepartoSelected(item)
        setFormView(206)
        setViewOpen(true)
    }
    const handleClose = (item) => {
        setRepartoSelected(item)
        setFormView(208)
        setViewOpen(true)
    }

    const handleDel = (item) => {
        setRepartoSelected(item)
        setFormView(207)
        setViewOpen(true)
    }


    return (
        <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50'>
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 text-white py-6 px-4 shadow-lg">
                <div className="max-w-7xl mx-auto">
                    <h1 className="text-3xl font-bold mb-2 flex items-center gap-2"><FaTruck /> Listado de Repartos</h1>
                    <p className="text-blue-100">Consulta y administra todos los repartos</p>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 py-8">
                {/* Filters Card */}
                <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-200">
                    <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                        <FaSearch /> Filtros de Búsqueda
                    </h2>

                    {/* Date Range */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                        <div>
                            <label htmlFor='fechainicio' className='text-gray-700 font-semibold mb-2 flex items-center gap-2'>
                                <FaCalendarAlt /> Fecha de Inicio
                            </label>
                            <input
                                type='date'
                                className='w-full p-3 rounded-lg border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white'
                                id='fechainicio'
                                value={fechaInicio}
                                onChange={(e) => setFechaInicio(e.target.value)}
                            />
                        </div>
                        <div>
                            <label htmlFor='fechafin' className='text-gray-700 font-semibold mb-2 flex items-center gap-2'>
                                <FaCalendarAlt /> Fecha de Fin
                            </label>
                            <input
                                type='date'
                                className='w-full p-3 rounded-lg border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white'
                                id='fechafin'
                                value={fechaFin}
                                onChange={(e) => setFechaFin(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* User Selector */}
                    {usuarios && (
                        <div className='mb-4'>
                            <label htmlFor='sUsuario' className='text-gray-700 font-semibold mb-2 flex items-center gap-2'>
                                <FaUser /> Repartidor
                            </label>
                            <select
                                className='py-3 px-4 w-full rounded-lg bg-white border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 text-gray-800 font-medium cursor-pointer hover:border-blue-400'
                                id='sUsuario'
                                value={usuario}
                                onChange={(e) => setUsuario(e.target.value)}
                            >
                                {usuarios.map((item, index) => (
                                    <option key={index} value={item.id}>{item.nombre}</option>))
                                }
                            </select>
                        </div>
                    )}

                    {/* Checkbox Filter */}
                    <div className='flex items-center gap-3 p-4 bg-blue-50 rounded-lg border-2 border-blue-200'>
                        <input
                            className='w-5 h-5 rounded text-blue-600 focus:ring-2 focus:ring-blue-500 cursor-pointer'
                            type='checkbox'
                            id='checkEstado'
                            onChange={() => setEstado(!estado)}
                            checked={estado}
                        />
                        <label htmlFor='checkEstado' className="text-gray-800 font-semibold cursor-pointer select-none flex items-center gap-2">
                            <FaFolderOpen /> Solo mostrar repartos abiertos
                        </label>
                    </div>
                </div>

                {/* Results Card */}
                {typeof repartos !== 'undefined' && (
                    <div className='bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200'>
                        {/* Table Header */}
                        <div className='bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-6'>
                            <h2 className='text-xl font-bold'>Resultados ({repartos.length})</h2>
                        </div>

                        {/* Table */}
                        <div className='overflow-x-auto'>
                            <table className='w-full'>
                                <thead>
                                    <tr className='bg-gradient-to-r from-blue-50 to-indigo-50 border-b-2 border-blue-200'>
                                        <th className='py-4 px-6 text-left text-sm font-bold text-gray-700 uppercase tracking-wider'>Fecha</th>
                                        <th className='py-4 px-6 text-left text-sm font-bold text-gray-700 uppercase tracking-wider'>Hora</th>
                                        <th className='py-4 px-6 text-right text-sm font-bold text-gray-700 uppercase tracking-wider'>Total Asignado</th>
                                        <th className='py-4 px-6 text-left text-sm font-bold text-gray-700 uppercase tracking-wider'>Repartidor</th>
                                        <th className='py-4 px-6 text-center text-sm font-bold text-gray-700 uppercase tracking-wider'>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        repartos.map((item, index) => {
                                            // Determine row background based on status
                                            let rowBg = 'hover:bg-gray-50';
                                            let statusBadge = null;

                                            if (item.saldo && item.saldo > 0 && item.saldo === item.total) {
                                                rowBg = 'bg-gradient-to-r from-red-50 to-rose-50 hover:from-red-100 hover:to-rose-100';
                                                statusBadge = <span className="inline-block px-2 py-1 text-xs font-bold rounded-full bg-red-500 text-white ml-2">Pendiente</span>;
                                            } else if (item.saldo > 0 && item.saldo < item.total) {
                                                rowBg = 'bg-gradient-to-r from-orange-50 to-amber-50 hover:from-orange-100 hover:to-amber-100';
                                                statusBadge = <span className="inline-block px-2 py-1 text-xs font-bold rounded-full bg-orange-500 text-white ml-2">Parcial</span>;
                                            } else if (item.estado !== '0') {
                                                rowBg = 'bg-gradient-to-r from-green-50 to-emerald-50 hover:from-green-100 hover:to-emerald-100';
                                                statusBadge = <span className="inline-block px-2 py-1 text-xs font-bold rounded-full bg-green-500 text-white ml-2">Cerrado</span>;
                                            }

                                            return (
                                                <tr key={index} className={`transition-all duration-200 border-b border-gray-100 ${rowBg}`}>
                                                    <td className='py-3 px-6 font-medium text-gray-800'>
                                                        <div className='flex items-center gap-2'>
                                                            <FaCalendarAlt className='text-gray-500' />
                                                            {item.fecha}
                                                        </div>
                                                    </td>
                                                    <td className='py-3 px-6 text-gray-700'>
                                                        <div className='flex items-center gap-2'>
                                                            <FaClock className='text-gray-500' />
                                                            {item.hora}
                                                        </div>
                                                    </td>
                                                    <td className='py-3 px-6 text-right font-bold text-gray-800'>
                                                        $ {item.total && parseFloat(item.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                                    </td>
                                                    <td className='py-3 px-6'>
                                                        <div className='flex items-center gap-2'>
                                                            <FaUser className='text-gray-500' />
                                                            <span className='font-medium text-gray-800'>{item.apellido}</span>
                                                            {statusBadge}
                                                        </div>
                                                    </td>
                                                    <td className='py-3 px-6'>
                                                        <div className='flex items-center justify-center gap-2 flex-wrap'>
                                                            <button
                                                                className='bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 rounded-lg py-2 px-4 text-white font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-1'
                                                                onClick={() => handleView(item)}
                                                            >
                                                                <FaEye /> Ver
                                                            </button>
                                                            {item.estado === '0' && (
                                                                <>
                                                                    <button
                                                                        className='bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 rounded-lg py-2 px-4 text-white font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-1'
                                                                        onClick={() => handleEdit(item)}
                                                                    >
                                                                        <FaEdit /> Editar
                                                                    </button>
                                                                    <button
                                                                        className='bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 rounded-lg py-2 px-4 text-white font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-1'
                                                                        onClick={() => handleClose(item)}
                                                                    >
                                                                        <FaLock /> Cerrar
                                                                    </button>
                                                                </>
                                                            )}
                                                            <button
                                                                className='bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 rounded-lg py-2 px-4 text-white font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-1'
                                                                onClick={() => handleDel(item)}
                                                            >
                                                                <FaTrash /> Eliminar
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                                <tfoot>
                                    <tr className='bg-gradient-to-r from-slate-100 to-gray-100 border-t-2 border-gray-300'>
                                        <td className='py-4 px-6 font-bold text-gray-800 text-lg flex items-center gap-2' colSpan="2">
                                            <FaDollarSign /> Total General
                                        </td>
                                        <td className='py-4 px-6 text-right font-bold text-blue-600 text-xl'>
                                            $ {total.toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                        </td>
                                        <td colSpan="2"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ListadoRepartos